import { z } from "zod";
import { defineWidget } from "@/lib/home/widget";

/** A short checklist for today, with "ask Kourai" on each task. */
export default defineWidget({
  type: "kourai.tasks",
  version: 1,
  title: "Tasks",
  description: "A checklist for today",
  sizes: ["s", "m", "l", "w", "xl"],
  defaultSize: "l",
  surfaces: ["newtab", "sidepanel"],
  data: "member",
  permissions: [],
  config: z.object({
    /** Done tasks stay listed (struck through) until cleared, or hide right away. */
    hideDone: z.boolean().default(false),
    /** Start with a few example tasks instead of an empty list (the default board's Tasks). */
    examples: z.boolean().default(false),
  }),
  load: () => import("./tasks-widget"),
});
